import { CreateRequestWithdrawFeatures } from 'features';
import React from 'react';

const CreateRequestWithdrawPage = () => {
  return <CreateRequestWithdrawFeatures />;
};

export default CreateRequestWithdrawPage;
